// src/store/draft.js
export default {
  namespaced: true,
  state: {
    // 电子病历
    electron: {},
    // 小结
    summary: {},
    // 当前用户的右侧tab
    patientTab: {},
  },
  getters: {
    getElectron(state) {
      return state.electron
    },
    getSummary(state) {
      return state.summary
    },
    getPatientTab(state) {
      return state.patientTab
    },
  },
  mutations: {
    __VUEX_MY_PERSISTEDSTATE_SET__(state, { key, value }) {
      state[key] = value;
    },
    setElectron(state, payload) {
      state.electron = payload
    },
    removeElectron(state, regId) {
      if (state.electron[regId]) {
        delete state.electron[regId];
      }
    },
    setSummary(state, payload) {
      state.summary = payload
    },
    removeSummary(state, regId) {
      if (state.summary[regId]) {
        delete state.summary[regId];
      }
    },
    SET_PATIENT_TAB(state, payload){
      state.patientTab = {
        ...state.patientTab,
        ...payload
      };
    }
  },
  actions: {
    // 可选：异步操作
    fetchUserInfo({ commit }, payload) {
      // 异步获取后 commit

    }
  }
}